<template>
  <div class="container">
    <button
      v-if="extraSectionIndex && removeSection"
      type="button"
      class="close"
      aria-label="Close"
      @click="() => removeSection(extraSectionIndex)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <Header :title="'Section 4: Disclosure and Reporting'" />
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <p>
          <strong
            >Did you reach out for help after the assault or abuse?</strong
          >
          <br />
          <em
            >If you are a survivor of multiple assaults or instances of abuse,
            we ask that you please list these experiences separately via
            multiple forms. You can add another from at the end of Section
            4.</em
          >
        </p>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="askedForHelpRadio"
              :checked="values.askedForHelpRadio1"
              @change="
                e =>
                  handleValueChanged('askedForHelpRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="askedForHelpRadio"
              :checked="values.askedForHelpRadio2"
              @change="
                e =>
                  handleValueChanged('askedForHelpRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">If yes, where did you turn?</label>
        <textarea
          class="form-control"
          rows="1"
          :value="values.helpFrom"
          @keyup="e => handleValueChanged('helpFrom', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong
            >Have you contacted the National Sexual Assault Hotline?</strong
          >
          <br />
          <em>Check all that apply</em>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.telephoneCheckbox"
              @change="
                e => handleValueChanged('telephoneCheckbox', e.target.checked)
              "
            />
            Telephone 800.656.HOPE
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.chatCheckbox"
              @change="
                e => handleValueChanged('chatCheckbox', e.target.checked)
              "
            />
            Online Chat (online.rainn.org)
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.spanishCheckbox"
              @change="
                e => handleValueChanged('spanishCheckbox', e.target.checked)
              "
            />
            RAINN’s Spanish Language Services (telephone, online chat, La Sala
            de Ayuda)
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.DoDCheckbox"
              @change="e => handleValueChanged('DoDCheckbox', e.target.checked)"
            />
            The DoD Safe Helpline (safehelpline.org or 877.995.5247)
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If you contacted any of these hotlines, how would you describe your
          experience? Is there anything about these services you want to share
          with other survivors?</label
        >
        <textarea
          class="form-control"
          rows="3"
          :value="values.hotlineExperience"
          @keyup="e => handleValueChanged('hotlineExperience', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong
            >Did you receive a sexual assault forensic exam (commonly known as a
            “rape kit”)?</strong
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitRadio"
              :checked="values.rapeKitRadio1"
              @change="
                e =>
                  handleValueChanged('rapeKitRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitRadio"
              :checked="values.rapeKitRadio2"
              @change="
                e =>
                  handleValueChanged('rapeKitRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If yes, where was the exam conducted? (City, State)</label
        >
        <textarea
          class="form-control"
          rows="1"
          :value="values.rapeKitLocation"
          @keyup="e => handleValueChanged('rapeKitLocation', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">Was the evidence tested by a lab?</label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitEvidenceRadio"
              :checked="values.rapeKitEvidenceRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitEvidenceRadio1',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitEvidenceRadio"
              :checked="values.rapeKitEvidenceRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitEvidenceRadio2',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            No
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitEvidenceRadio"
              :checked="values.rapeKitEvidenceRadio3"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitEvidenceRadio3',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Don't Know
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label"
          >Did the testing identify a perpetrator(s)?</label
        >
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitIdetifyRadio"
              :checked="values.rapeKitIdentifyRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitIdentifyRadio1',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitIdetifyRadio"
              :checked="values.rapeKitIdentifyRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitIdentifyRadio2',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            No
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="rapeKitIdetifyRadio"
              :checked="values.rapeKitIdentifyRadio3"
              @change="
                e =>
                  handleValueChanged(
                    'rapeKitIdentifyRadio3',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Don't Know
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong>Did you report the incident(s) to police?</strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportRadio"
              :checked="values.reportRadio1"
              @change="
                e =>
                  handleValueChanged('reportRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportRadio"
              :checked="values.reportRadio2"
              @change="
                e =>
                  handleValueChanged('reportRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If no, why did you choose not to report?</label
        >
        <textarea
          class="form-control"
          rows="1"
          :value="values.noReportReason"
          @keyup="e => handleValueChanged('noReportReason', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">If yes, was an arrest made?</label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportArrestRadio"
              :checked="values.reportArrestRadio1"
              @change="
                e =>
                  handleValueChanged('reportArrestRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportArrestRadio"
              :checked="values.reportArrestRadio2"
              @change="
                e =>
                  handleValueChanged('reportArrestRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If yes, how long after the experience did a trial take place/was a
          plea bargain reached?</label
        >
        <textarea
          class="form-control"
          rows="1"
          :value="values.reportPlea"
          @keyup="e => handleValueChanged('reportPlea', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">Was the perpetrator(s) convicted?</label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportConvictionRadio"
              :checked="values.reportConvictionRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'reportConvictionRadio1',
                    e.target.checked,
                    { radio: 2 }
                  )
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="reportConvictionRadio"
              :checked="values.reportConvictionRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'reportConvictionRadio2',
                    e.target.checked,
                    { radio: 2 }
                  )
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">Additional details:</label>
        <textarea
          class="form-control"
          rows="1"
          :value="values.reportAdditionalDetails"
          @keyup="
            e => handleValueChanged('reportAdditionalDetails', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong>Did you report to any other authorities?</strong>
          <br />
          <em>For example, campus police or Child Protective Services</em>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="otherReportRadio"
              :checked="values.otherReportRadio1"
              @change="
                e =>
                  handleValueChanged('otherReportRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="otherReportRadio"
              :checked="values.otherReportRadio2"
              @change="
                e =>
                  handleValueChanged('otherReportRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If yes, what was the result of that experience?</label
        >
        <textarea
          class="form-control"
          rows="1"
          :value="values.otherReportExperience"
          @keyup="
            e => handleValueChanged('otherReportExperience', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Were you prevented from seeking justice by any other factors, such
            as the Statute of Limitations?</strong
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.otherReportLimitations"
          @keyup="
            e => handleValueChanged('otherReportLimitations', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Is there any additional information you’d like to share regarding
            the reporting process?</strong
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.otherReportAdditionalInformation"
          @keyup="
            e =>
              handleValueChanged(
                'otherReportAdditionalInformation',
                e.target.value
              )
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong
            >To your knowledge, did the perpetrator(s) have any additional
            encounters with the criminal justice system?</strong
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="perpetratorAdditionalEncounterRadio"
              :checked="values.perpetratorAdditionalEncounterRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorAdditionalEncounterRadio1',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Arrests
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="perpetratorAdditionalEncounterRadio"
              :checked="values.perpetratorAdditionalEncounterRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorAdditionalEncounterRadio2',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Convictions
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="perpetratorAdditionalEncounterRadio"
              :checked="values.perpetratorAdditionalEncounterRadio3"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorAdditionalEncounterRadio3',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Unknown
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">Additional Details:</label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.additionalDetails"
          @keyup="e => handleValueChanged('additionalDetails', e.target.value)"
        />
      </div>
    </div>
    <div v-if="!!addAdditionalSection" class="row mt-2">
      <div class="col">
        <button
          class="btn btn-secondary btn-sm"
          type="button"
          @click="addAdditionalSection"
        >
          Add Additional Section 4 Form
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionFour } from "@/typings/application";

export default {
  name: "sectionFour",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionFour,
      required: true,
      default: () => {
        return new SectionFour();
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSection: {
      type: Function,
      required: false,
      default: null
    },
    removeSection: {
      type: Function,
      required: false,
      default: null
    },
    extraSectionIndex: {
      type: Number,
      required: false,
      default: -1
    }
  },
  methods: {
    handleValueChanged(name, value, details) {
      const sectionName =
        this.extraSectionIndex && this.extraSectionIndex > 0
          ? `section4_${this.extraSectionIndex}`
          : "section4";
      this.onValueChanged(sectionName, name, value);
      if (details && details.radio) {
        // Ensures that only one radio within a radio group is selected at a
        // time.
        const radio = name.split("Radio");
        const index = parseInt(radio[1]);
        for (let i = 1; i <= details.radio; i++) {
          if (index !== i) {
            this.onValueChanged(sectionName, `${radio[0]}Radio${i}`, false);
          }
        }
      }
    }
  }
};
</script>

<style></style>
